import MenuItem from '@mui/material/MenuItem';
import { Logout } from '@otp/icons';
import { useTranslation } from 'react-i18next';
import styles from './index.module.css';
import { useMutation } from '@apollo/client';
import { StopImpersonatingUserDocument } from 'src/graphql/generated/graphql';
import { clearImpersonatorJWTToken, saveJWTToken } from 'src/utils/auth';
import { Routes } from '../router/constants';

export const StopImpersonatingMenuItem = () => {
  const { t } = useTranslation();

  const [stopImpersonatingUser] = useMutation(StopImpersonatingUserDocument);

  const onStopImpersonatingClick = async () => {
    const { data } = await stopImpersonatingUser();

    if (data?.stopImpersonatingUser) {
      clearImpersonatorJWTToken();
      saveJWTToken(data.stopImpersonatingUser);
      window.location.href = Routes.home.path;
    }
  };

  return (
    <MenuItem onClick={onStopImpersonatingClick} className={styles.menuItem}>
      <Logout /> {t('common.stop-impersonating')}
    </MenuItem>
  );
};
